import { Link } from 'react-router-dom';
import styled, { css } from 'styled-components';

/** `muted`: ação ainda travada, em cinza e sem o esmaecido do disabled. */
export type PillVariant = 'green' | 'dark' | 'muted';
export type PillSize = 'md' | 'lg';

interface PillProps {
  $variant: PillVariant;
  $size: PillSize;
}

// Mesma altura e tamanho de texto do .btn e do .btn-lg do Bootstrap usados na
// plataforma; só as laterais são mais largas, por causa do formato de pílula.
const sizes = {
  md: css`
    gap: 4px;
    padding: 0.375rem 2rem;
    font-size: 1rem;
  `,
  lg: css`
    gap: 8px;
    padding: 0.5rem 2.5rem;
    font-size: 1.25rem;

    img {
      transform: scale(1.33);
    }
  `,
};

const pill = css<PillProps>`
  display: inline-flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  border: 1px solid transparent;
  border-radius: 80px;
  background: ${(props) =>
    ({ green: props.theme.$dark_green, dark: props.theme.$dark, muted: props.theme.$gray500 }[
      props.$variant
    ])};
  color: ${(props) => props.theme.$white};
  font-weight: 900;
  line-height: 1.5;
  white-space: nowrap;
  ${(props) => sizes[props.$size]}
  cursor: pointer;
  transition: filter 0.15s ease;

  &:hover,
  &:focus {
    color: ${(props) => props.theme.$white};
    text-decoration: none;
    filter: brightness(1.1);
  }

  &:focus-visible {
    box-shadow: 0 0 0 3px rgba(13, 135, 94, 0.35);
  }

  &:disabled {
    cursor: not-allowed;
    filter: none;
    opacity: ${(props) => (props.$variant === 'muted' ? 1 : 0.55)};
  }
`;

export const Button = styled.button<PillProps>`
  ${pill}
`;

export const Anchor = styled.a<PillProps>`
  ${pill}
`;

export const RouterLink = styled(Link)<PillProps>`
  ${pill}
`;
